export function getCookieClient(name: string): string | null {
  if (typeof document === "undefined") return null;
  const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  // The cookie name is not user-controlled, so we can safely use a non-literal regular expression.
  // nosemgrep: javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp
  const match = new RegExp(`(?:^|; )${escapedName}=([^;]*)`).exec(document.cookie);
  return match?.[1] != null ? decodeURIComponent(match[1]) : null;
}

export function setCookieClient(name: string, value: string): void {
  if (typeof document === "undefined") return;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=31536000; samesite=lax`;
}
